import { render } from "./OrganizationCallLogNotificationFields.vue?vue&type=template&id=7b4e3d84"
import script from "./OrganizationCallLogNotificationFields.vue?vue&type=script&lang=js"
export * from "./OrganizationCallLogNotificationFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__